import React from 'react';
import {
    Dialog,
    DialogContent,
    CardContent,
    Typography,
    AccordionSummary,
    AccordionDetails,
    Grid,
    Button,
    Hidden
} from '@material-ui/core';
import ListIcon from '@material-ui/icons/List';
import clsx from 'clsx';

import { StudentProfile } from '../../../utils/services/cache/ClientCache';
import { Coin } from '../../shared/component';
import useStyles from '../../../styles/components/survey/stylesSurvey';

const CompletedSurveyModal = ({ isOpen, extraContent, closeAction, viewSummary, surveyName, gradeText, recommendation }) => {
    const classes = useStyles()
    let currentRewardPoint = StudentProfile.getRewardPoint();
    let lastSurveyContent = <span>Section Completed</span>

    if (extraContent != null && extraContent.isLastSection) {
        lastSurveyContent =
            <span>
                Congratulations! You just completed all the sections from this survey. You earned extra bonus coins.
            </span>
    }

    return (
        <Dialog 
            classes={{ paperWidthFalse: classes.paperWidthFalse }}
            fullWidth={true}
            maxWidth={false}
            open={isOpen}>
            <DialogContent classes={{root: classes.rootDialogContent}}>   
                    <Grid container justify="center" classes={{root: classes.rootGridHead}}>
                        <Grid 
                            container 
                            justify="center" 
                            direction="column" 
                            alignItems="center" 
                            item xs={12} 
                            classes={{ root: classes.rootWrapperTitle }}
                        >
                            <div className={clsx(classes.textDialog, classes.textDialogTitle)}>
                                Submission Successful!
                            </div>
                            <div className={clsx(classes.textDialog, classes.textDialogDescription)}>
                                {lastSurveyContent}
                            </div>
                        </Grid>
                    </Grid>
                    <CardContent classes={{root: classes.rootCard}}>
                        <Grid
                            container
                            direction="column"
                            justify="center"
                            alignItems="center">

                            <AccordionSummary>
                                <Grid
                                    container
                                    direction="column"
                                    justify="center"
                                    alignItems="center">
                                    <Typography className="adventurelearn__header">
                                        {surveyName}
                                    </Typography>
                                    {
                                        gradeText.length > 0 ?
                                            <Typography className="completedsurvey__gradespace">
                                                {gradeText}
                                            </Typography>
                                            : ''
                                    }
                                    {
                                        recommendation && recommendation !== '' ?
                                            <Grid 
                                                container 
                                                justify="center" 
                                                alignItems="center"
                                                classes={{ root: classes.wrapperRecommendations }}
                                            >
                                                <div>
                                                    <ListIcon style={{ color: 'white' }}/>
                                                </div>
                                                <div className={classes.textRecommendations}>
                                                    Recommendations
                                                </div>
                                            </Grid>
                                            : ''
                                    }
                                    {
                                        (extraContent != null && !extraContent.isTraitSection) ?
                                            <Typography className="completedsurvey__gradespace">
                                                Thank you for completing this section!
                                                </Typography>
                                            : ''
                                    }

                                </Grid>
                            </AccordionSummary>
                            {
                                recommendation && recommendation !== '' ?
                                    <AccordionDetails>
                                        <div dangerouslySetInnerHTML={{ __html: recommendation }} className="completedsurvey__recommendation__body"/>
                                    </AccordionDetails>
                                    : ''
                            }
                            {extraContent != null &&
                                <Grid
                                    container
                                    direction="row"
                                    alignItems="center"
                                    justify="center"
                                    classes={{ root: classes.rootContainerCoin }}
                                    spacing={2}
                                >
                                    <Grid item xs={6} sm={6} container justify="flex-end" alignItems="center">
                                        <div>
                                            <Hidden smDown>
                                                <Coin size="medium" coin={`+${extraContent.rewardPoint}`}/>
                                            </Hidden>
                                            <Hidden mdUp>
                                                <Coin size="small" coin={`+${extraContent.rewardPoint}`}/>
                                            </Hidden>
                                        </div>
                                        <div className={classes.textContent}>Coins Earned</div>
                                    </Grid>
                                    <Grid item xs={6} sm={6} container justify="flex-start" alignItems="center">
                                        <div>
                                            <Hidden smDown>
                                                <Coin size="medium" coin={parseInt(currentRewardPoint) + extraContent.rewardPoint}/>
                                            </Hidden>
                                            <Hidden mdUp>
                                                <Coin size="small" coin={parseInt(currentRewardPoint) + extraContent.rewardPoint}/>
                                            </Hidden>
                                        </div>
                                        <div className={classes.textContent}>New Balance</div>
                                    </Grid>
                                </Grid>
                            }
                            {
                                extraContent != null ?
                                    <>
                                        {
                                            extraContent != null && extraContent.isLastSection ?

                                                <Button 
                                                    onClick={() => viewSummary()}
                                                    classes={{ root: classes.rootButtonDialog }}
                                                >
                                                    View Survey Summary
                                                </Button>
                                                :
                                                <Button 
                                                    onClick={() => closeAction()}
                                                    classes={{ root: classes.rootButtonDialog }}
                                                >
                                                    Surveys
                                                </Button>

                                        }
                                    </>
                                    :
                                    <Button 
                                        onClick={() => closeAction()}
                                        classes={{ root: classes.rootButtonDialog }}
                                    >
                                        Close
                                    </Button>
                            }
                        </Grid>

                    </CardContent>

            </DialogContent>

        </Dialog>
    );
}

export { CompletedSurveyModal as default }